module.exports = __webpack_public_path__ + "img/Nosotros_Ap3-gallery.f5cca229.jpg";